/* EcomHub Pro — Horizontal Ticker: fill the bar and loop seamlessly for any item count */
(function () {
  function build(bar) {
    var marquee = bar.querySelector('[data-ehp-marquee]');
    if (!marquee) return;
    var groups = marquee.querySelectorAll('.ehp-tkr__group');
    if (!groups.length) return;

    // reset to a single base group (remove clones from earlier builds)
    var base = groups[0];
    for (var i = groups.length - 1; i >= 1; i--) groups[i].remove();

    var containerW = bar.clientWidth;
    if (!containerW || marquee.scrollWidth === 0) return;

    // fill: clone the base group until one "half" spans at least the full bar width
    var guard = 0;
    while (marquee.scrollWidth < containerW && guard < 200) {
      var c = base.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      marquee.appendChild(c);
      guard++;
    }

    var halfW = marquee.scrollWidth;
    var cs = getComputedStyle(marquee);
    var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;

    // duplicate the whole filled half so the scroll can loop seamlessly
    var half = Array.prototype.slice.call(marquee.children);
    var frag = document.createDocumentFragment();
    half.forEach(function (n) {
      var d = n.cloneNode(true);
      d.setAttribute('aria-hidden', 'true');
      frag.appendChild(d);
    });
    marquee.appendChild(frag);

    // shift by exactly one half + the connecting gap so the copy lands on the original
    var shift = halfW + gap;
    marquee.style.setProperty('--ehp-tkr-shift', shift + 'px');

    // keep the scroll speed consistent regardless of content length
    var speed = parseFloat(marquee.getAttribute('data-speed')) || 30;
    var dur = speed * (shift / containerW);
    marquee.style.animationDuration = dur.toFixed(2) + 's';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.ehp-tkr').forEach(build);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* ⚠️⚠️ REBUILDING RESTARTS THE MARQUEE FROM THE BEGINNING — it re-clones the
     groups and reassigns animationDuration, which resets the CSS animation. It
     was wired to EVERY resize, and on a phone the address bar hiding on scroll
     fires resize with an unchanged WIDTH, so simply scrolling the page made the
     ticker jump back to the start. A height change cannot affect a horizontal
     marquee's measurements — only rebuild when the width actually changes. */
  var rt;
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    clearTimeout(rt);
    rt = setTimeout(function () { initAll(); }, 200);
  });
  window.addEventListener('orientationchange', function () {
    lastW = window.innerWidth;
    clearTimeout(rt);
    rt = setTimeout(function () { initAll(); }, 300);
  });
})();
